import { GetterTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import { itemStateConstant } from "../../../../common";

const documentGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
	service: (state: IPropertyEditState) => state.service,
	listOfPropertyDocuments: (state: IPropertyEditState) => {
		return [...(state.property.Documents || [])].filter(
			c => c.ItemState != itemStateConstant.Deleted
		);
	},

	listOfChildPropertyDocumentsByGroupId: (state: IPropertyEditState) => (
		groupId: number
	) => {
		return [...(state.property.Documents || [])].filter(
			c => c.GroupId == groupId
		);
	},

	getPropertyDocumentLevel: (state: IPropertyEditState) => (id: number) => {
		let level = 0;
		let currentItem = [...state.property.Documents].find(c => c.Id == id);
		if (currentItem === null || currentItem.GroupId === null) return level;

		while (true) {
			var parrentItem = [...state.property.Documents].find(
				c => c.Id == currentItem.GroupId
			);
			if (parrentItem == null) {
				return level;
			}

			currentItem = parrentItem;
			level = level + 1;
		}
	},

	checkPropertyDocumentHasChilds: (state: IPropertyEditState) => (id: number) => {
		let currentItem = [...state.property.Documents].find(c => c.Id == id);
		if (currentItem === null) return false;

		var childItems = [...state.property.Documents].find(
			c => c.GroupId == currentItem.Id
		);
		return childItems != null;
	}
};

export default documentGetters;
